import { SignUpFormData } from ".";
import SignUpMethod from "./signUpPages/signUpMethod";
import EmailForm from "./signUpPages/emailForm";
import NameForm from "./signUpPages/nameForm";
import AddressForm from "./signUpPages/addressForm";
import EmailVerificationForm from "./signUpPages/phoneVerificationForm";
import BusinessInfoForm from "./signUpPages/businessInfo";
import PrivacyContactForm from "./signUpPages/privacyContact";
import BusinessRegistrationForm from "./signUpPages/businessRegistrationForm";
import SignatureForm from "./signUpPages/signatureForm";
import UserReviewForm from "./signUpPages/userReviewForm";
import VendorReviewForm from "./signUpPages/vendorReviewForm";

export interface SignUpPageItem {
  pageName: string;
  component: (props: SignUpFormData) => JSX.Element;
}

export const SignUpPages: SignUpPageItem[] = [
  {
    pageName: "signUpMethod",
    component: (props) => <SignUpMethod setAccount={props.setAccount} />,
  },
  {
    pageName: "emailForm",
    component: (props) => (
      <EmailForm signUpData={props.account} setSignUpData={props.setAccount} />
    ),
  },
  {
    pageName: "nameForm",
    component: (props) => (
      <NameForm signUpData={props.account} setSignUpData={props.setAccount} />
    ),
  },
  {
    pageName: "addressForm",
    component: (props) => (
      <AddressForm
        signUpData={props.account}
        setSignUpData={props.setAccount}
      />
    ),
  },
  {
    pageName: "emailVerificationForm",
    component: (props) => (
      <EmailVerificationForm
        signUpData={props.account}
        setSignUpData={props.setAccount}
      />
    ),
  },
  {
    pageName: "businessInfoForm",
    component: (props) => (
      <BusinessInfoForm
        signUpData={props.vendor}
        setSignUpData={props.setVendor}
        account={props.account}
        setAccount={props.setAccount}
      />
    ),
  },
  {
    pageName: "privacyContactForm",
    component: (props) => (
      <PrivacyContactForm
        signUpData={props.vendor}
        setSignUpData={props.setVendor}
        account={props.account}
      />
    ),
  },
  {
    pageName: "businessRegistrationForm",
    component: (props) => (
      <BusinessRegistrationForm
        signUpData={props.vendor}
        setSignUpData={props.setVendor}
      />
    ),
  },
  {
    pageName: "signatureForm",
    component: (props) => <SignatureForm signUpData={props} />,
  },
  {
    pageName: "userReviewForm",
    component: (props) => (
      <UserReviewForm
        signUpData={props.account}
        setSignUpData={props.setAccount}
      />
    ),
  },
  {
    pageName: "vendorReviewForm",
    component: (props) => <VendorReviewForm signUpData={props} />,
  },
];
